module.exports = __webpack_public_path__ + "media/reference2.581b97ca.mp3";